import { useEffect, useMemo } from "react";
import Mousetrap from "mousetrap";
import "mousetrap/plugins/global-bind/mousetrap-global-bind";
import { ShortcutConfig, ShortcutMap } from "./types";
import { shortcutMapToArray, shouldIgnoreEvent } from "./utils";

interface UseKeyboardShortcutsOptions {
  shortcuts: ShortcutConfig[] | ShortcutMap;
  enabled?: boolean;
}

export const useKeyboardShortcuts = ({
  shortcuts,
  enabled = true,
}: UseKeyboardShortcutsOptions) => {
  const shortcutsArray = useMemo(() => {
    return Array.isArray(shortcuts) ? shortcuts : shortcutMapToArray(shortcuts);
  }, [shortcuts]);

  useEffect(() => {
    if (!enabled) return;

    shortcutsArray.forEach(({ key, handler, preventDefault = true }) => {
      Mousetrap.bind(key, (e) => {
        if (shouldIgnoreEvent(e)) {
          return;
        }

        if (preventDefault) {
          if (e.preventDefault) e.preventDefault();
          else e.returnValue = false;
        }
        handler(e);
      });
    });

    return () => {
      shortcutsArray.forEach(({ key }) => {
        Mousetrap.unbind(key);
      });
    };
  }, [enabled, shortcutsArray]);
};
